const TariffCalculator = () => {
	const calculatorContainer = document.querySelector('#tariff-calculator');
	if(!calculatorContainer) {
		return;
	}

	// Get the select boxes and other elements
	const destinationSelect = calculatorContainer.querySelector('#destination-select');
	const loaSelect = calculatorContainer.querySelector('#loa-select');
	const operationsTable = calculatorContainer.querySelector('table');
	const totalTariffSpan = calculatorContainer.querySelector('#total-tariff');
	const totalBunkerSurchargeSpan = calculatorContainer.querySelector('#total-bunker-surcharge');
	const totalTowageChargesSpan = calculatorContainer.querySelector('#total-towage-charges');

	if(!destinationSelect || !loaSelect || !operationsTable || !totalTariffSpan || !totalBunkerSurchargeSpan || !totalTowageChargesSpan) {
		console.error('Some elements of the tariff calculator were not found');
		return;
	}

	// Calculator data is exposed to the global scope
	const calculatorData = window.tariffCalculatorCalculatorData;
	const bunkerSurcharge = window.tariffCalculatorBunkerSurcharge;

	const formatPrice = (price) => {
		return price.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
	};

	const updateOperationSubtotal = (operationRow) => {
		const subtotalCell = operationRow.querySelector('.subtotal');
		subtotalCell.textContent = formatPrice(calculateSubtotal(operationRow));
	};

	const updateBunkerSurcharge = (totalTariff) => {
		const bunkerSurchargeAmount = (bunkerSurcharge / 100) * totalTariff;
		totalBunkerSurchargeSpan.textContent = formatPrice(bunkerSurchargeAmount);
		return bunkerSurchargeAmount;
	};

	const updateTotalTowageCharges = (totalTariff, bunkerSurchargeAmount) => {
		const totalTowageCharges = totalTariff + bunkerSurchargeAmount;
		totalTowageChargesSpan.textContent = formatPrice(totalTowageCharges);
	};

	const calculateSubtotal = (operationRow) => {
		const tugsRequired = Number(operationRow.querySelector('.tugs-required').value);
		const tariffPerTugText = operationRow.querySelector('.tariff-per-tug').textContent;
		const tariffPerTug = Number(tariffPerTugText.replace(/[^0-9.]/g, "")); // Remove non-numeric characters
		return tugsRequired * tariffPerTug;
	};

	const updateTotalTariff = () => {
		const subtotalCells = operationsTable.querySelectorAll('tbody .operation-row[data-destination-id="' + destinationSelect.value + '"] .subtotal');
		const totalTariff = Array.from(subtotalCells).reduce((sum, cell) => {
			const cellText = cell.textContent.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
			return sum + Number(cellText);
		}, 0);

		totalTariffSpan.textContent = formatPrice(totalTariff);
		return totalTariff;
	};

	const toggleOperationRows = (selectedDestinationId) => {
		const operationRows = operationsTable.querySelectorAll('tbody .operation-row');
		operationRows.forEach((row) => {
			if (row.dataset.destinationId === selectedDestinationId) {
				row.style.display = ''; // Show row
			} else {
				row.style.display = 'none'; // Hide row
			}
		});
	};

	const updateOperationsTable = () => {
		const selectedDestinationId = destinationSelect.value;
		const selectedLoa = loaSelect.value;

		const selectedDestination = calculatorData.find(dest => dest.id === selectedDestinationId);
		if (!selectedDestination) {
			console.error('Selected destination is undefined');
			return;
		}

		const operationRows = operationsTable.querySelectorAll('tbody .operation-row[data-destination-id="' + selectedDestinationId + '"]');
		operationRows.forEach((operationRow, index) => {
			const operation = selectedDestination.operations[index];
			if (!operation) {
				console.error('Operation is undefined, row:', operationRow);
				return;
			}

			operationRow.querySelector('.tariff-per-tug').textContent = formatPrice(Number(operation.loa[selectedLoa]) || 0);
			updateOperationSubtotal(operationRow);
		});

		const totalTariff = updateTotalTariff();
		const bunkerSurchargeAmount = updateBunkerSurcharge(totalTariff);
		updateTotalTowageCharges(totalTariff, bunkerSurchargeAmount);
	};

	// Initialize the table view
	toggleOperationRows(destinationSelect.value); // Hide/Show rows based on the initial destination
	updateOperationsTable();

	// Event listeners
	destinationSelect.addEventListener('change', () => {
		const selectedDestinationId = destinationSelect.value;
		toggleOperationRows(selectedDestinationId);
		updateOperationsTable();
	});

	loaSelect.addEventListener('change', updateOperationsTable);

	operationsTable.addEventListener('change', (event) => {
		if (event.target.classList.contains('tugs-required')) {
			const operationRow = event.target.closest('tr');
			updateOperationSubtotal(operationRow);
			const totalTariff = updateTotalTariff();
			const bunkerSurchargeAmount = updateBunkerSurcharge(totalTariff);
			updateTotalTowageCharges(totalTariff, bunkerSurchargeAmount);
		}
	});
};

export default TariffCalculator;
